// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__wI9_G","rotate-forever":"Spinner_rotate-forever__32Sr6"};